module.exports = __webpack_public_path__ + "media/images/guide/image5-7a979e815edca9c9fcf7b4b756b67a8f.png";